export default function formatTimeDuration(millis) {
    const hours = padTo2Digits(parseInt(millis / 3600000)).toString().split(".")[0];
    const min = padTo2Digits(parseInt(millis / 60000) % 60);

    return (hours+"h:"+min+"m")
}

export function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}

export function formatACtoOnOff(bool) {
    if(bool == true){
        return "ON";
    }else if(bool == false){
        return "OFF";
    }else{
        return "NA";
    }
}